import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';

class NewsList extends PureComponent {
    static propTypes = {
        content: PropTypes.array
    };

    render() {
        const { content } = this.props;

        return (
            <div className={styles.newsListWp}>
                <img className={styles.newsImage} src={require('../../assets/newsTitle.png')} alt="要闻" />
                <div className={styles.newsList}>
                    {
                        content.map((item, index) => {
                            return (
                                <div className={styles.news} key={index}>
                                    <div className={styles.title}>
                                        <a href={item.url} target="_blank" rel="noreferrer">{item.title}</a>
                                    </div>
                                    <div>
                                        {
                                            item.children && item.children.filter((a, i) => i % 2 === 0).map((i, idx) => {
                                                return (
                                                    <p key={idx}>
                                                        <span><a href={item.children[2 * idx].url} target="_blank" rel="noreferrer">{item.children[2 * idx].title}</a></span>
                                                        {
                                                            item.children[2 * idx + 1] &&
                                                            <> | <span><a href={item.children[2 * idx + 1].url} target="_blank" rel="noreferrer">{item.children[2 * idx + 1].title}</a></span></>
                                                        }
                                                    </p>
                                                );
                                            })
                                        }
                                    </div>
                                </div>
                            );
                        })
                    }
                </div>
            </div>
        );
    }
}

export default NewsList;
